<template>
  <div class="main">
    <div  class="power"  v-for="(item,index) in powerList" :key="index">
      <img class="power_img" :src="item.icon" alt="">
      <p>{{item.desc}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props:['powerList'],
  data(){
    return{
      
    }
  }
}
</script>

<style scoped lang="less">
.main{
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
// .power:nth-of-type(1){
//   width: 100% !important;
// }
.power{
  padding-top: .5rem;
  height: 1.35rem;
  width: 33.3%;
}
.power .power_img{
  width: .92rem;
  height: .92rem;
  display: block;
  box-sizing: border-box;
  margin: 0 auto;
  border-radius: 50%;
}
.power p{
  height:.33rem;
  font-size:.28rem;
  font-family:PingFang-SC-Regular,PingFang-SC;
  font-weight:400;
  color:rgba(250,222,185,1);
  text-align: center;
  margin-top: .1rem;
}
</style>